import React from 'react';
import { useState} from "react";
import { useDispatch} from 'react-redux'
import { Link, useNavigate } from "react-router-dom";
import { doLogin } from '../../Service';
import { setToken,setUserData } from '../../reducers/User/action';


export default function LoginHome(){ 
    const dispatch=useDispatch();
    const navigation = useNavigate();
    const initialValues = { username: "", password: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});

    const hanldeChange = (e) => {
			formValues[e.target.name]=  e.target.value;
			setFormValues(formValues);
		}

		const handleSubmit = (e) => {
			e.preventDefault();
			const errorCount = validate(formValues);
			setFormErrors(errorCount);
      if(errorCount.status){

        localStorage.clear();
				var bodyFormData = new FormData();
				bodyFormData.append('email', formValues.username);
				bodyFormData.append('password', formValues.password);
        doLogin(bodyFormData).then(res => handleResponse(res))

			}
		}

    const handleResponse = (response) => {
      if(response.data.code==200){
        localStorage.setItem('admin_api_token', response.data.data.token);
        dispatch(setUserData(response.data.data.user));
        dispatch(setToken(response.data.data.token));
        
        if(response.data.data.user.user_role==2)
        {
          navigation("/Exhibitorhome");
        }
        else
        {
          navigation("/home");
        }
        
      } else {
        const errors = {};
        errors.invalid = response.data.message;
        errors.status = false;
        setFormErrors(errors);
      }  
    }


		const validate = (values) => {
			const errors = {};
			const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
			errors.status = true;

			if(!values.username){
				errors.username = 'Username is required';
				errors.status = false;
			} else if (!regex.test(values.username)) {
				errors.username = "This is not a valid email format!";
				errors.status = false;
      }

			if(!values.password){
				errors.password = 'Password is required';
				errors.status = false;
			}
			return errors;
		}


    

  // JSX code for login form
    const renderForm = (

    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <label>Email Address </label>
          <input type="text" name="username" defalutValue={formValues.username} onChange={hanldeChange} />
          <p className="error">{formErrors.username}</p>
        </div>
        <div className="input-container">
          <label>Password </label>
          <input type="password" name="password" defalutValue={formValues.username} onChange={hanldeChange} />
          <p className="error">{formErrors.password}</p>
          <p className="error">{formErrors.invalid}</p>
        </div>
        <div className="message">
          <div className='left'>
            <div className='form-group'>
              <input type="checkbox" id="RememberME"/>
              <label for="RememberME">Remember me</label>
            </div>
          </div>
          <div className='right'><Link to='/forgotpassword'>Forgot your password</Link></div>
        </div>
        <div className="button-container">
          <input type="submit" onClick={handleSubmit} value="Login"/>
        </div>
        <div><Link className="create_an_account" to='/accountregister'>Create an Account</Link>
        </div>
      </form>
    </div>
   
   );

   return (
  
  <section className="Login-container" >
    <div className='container'>   
        <div className='row'>
          <div className='co1-md-12'>
            <img className='img-responsive' src={process.env.PUBLIC_URL+'/assets/logo.png'}/>
            <h1>Login</h1>
            {renderForm}
          </div>
        </div>
     </div>
  </section>  
 
 
 
 
   );
 }